import { render, staticRenderFns } from "./BusinessCardV2.vue?vue&type=template&id=67636d15&scoped=true"
import script from "./BusinessCardV2.vue?vue&type=script&lang=js"
export * from "./BusinessCardV2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67636d15",
  null
  
)

export default component.exports